export class UserAdministratePark {
	public id: string;
	public user_id: string;
	public park_id: string;
	public created_at: Date;
	public closed_at: Date;
	public usr_name_complete: string;
  public prefix: string;

	constructor(server_obj: any) {
		this.prefix = 'uad_';
		if (server_obj) {
			this.id                = server_obj[this.prefix + 'id'];
			this.user_id           = server_obj[this.prefix + 'user_id'];
			this.park_id           = server_obj[this.prefix + 'park_id'];
			this.created_at        = server_obj[this.prefix + 'created_at'];
			this.closed_at         = server_obj[this.prefix + 'closed_at'];
      this.usr_name_complete = server_obj['usr_name'] + ' ' + server_obj['usr_surname'];
		}
	}
}
